import {ApiClass} from "./ApiClass";
import {API_URL} from "../../constants/CONST";
import {UserWithStats} from "../../models/UserWithStats";
import {PlatformType} from "../../components/selectGameMode/SelectGameMode";


class PlayersStatsApiClass extends ApiClass {

    async getLeaderboard(platform: PlatformType, gameModeId: number): Promise<UserWithStats[] | null> {
        try {
            const res = await fetch(API_URL + `/leaderboard/${platform}/${gameModeId}`, {
                method: "GET",
                headers: this.jsonHeader
            })

            const data = await res.json();
            return data.map((obj: any) => new UserWithStats(obj))
        } catch (e) {
            return null
        }
    }
    
    
    async getPlayerStats(userId: number, platform: PlatformType, gameModeId: number): Promise<[UserWithStats | null, boolean]> {
        try {
            const res = await fetch(API_URL + `/stats/${platform}/${gameModeId}/${userId}`, {
                method: "GET",
                headers: this.jsonHeader
            })

            const userWithStats = new UserWithStats(await res.json());
            return [userWithStats, res.status !== 206] // 206 = partial content (no stats for this game mode)
        } catch (e) {
            return [null, false]
        }
    }
}

export const PlayersStatsApi = new PlayersStatsApiClass();
